module.exports = __webpack_public_path__ + "static/media/wheel.6b612d6d.png";